<template>
    <search-multiselect
        id="lockout-properties"
        v-model="selectedProperties"
        :options="propertyOptions"
        placeholder="Properties"
        controlValue="Properties"
    ></search-multiselect>
</template>

<script>
import SearchMultiselect from '../../generic/search-multiselect/search-multiselect.vue';

export default {
    name: 'LockoutPropertysSelect',
    components: {
        SearchMultiselect,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        initialValue: {
            type: Array,
            default: null,
        },
        properties: {
            type: Array,
            default: () => [],
        },
        variant: {
            type: String,
            default: '',
        },
        error: {
            type: String,
            default: null,
        },
    },
    computed: {
        propertyOptions() {
            return this.properties;
        },
        selectedProperties: {
            get: function () {
                return this.value;
            },
            set: function (selectedProperties) {
                this.$emit('input', selectedProperties);
            },
        },
    },
};
</script>
